export const salutations = [
  { description: 'Mr.', value: 'Mr.' },
  { description: 'Mrs.', value: 'Mrs.' },
  { description: 'Ms.', value: 'Ms.' },
  { description: 'Dr.', value: 'Dr.' },
];
